import { render, staticRenderFns } from "./PurchasingDocuments.vue?vue&type=template&id=64814f13&scoped=true&"
import script from "./PurchasingDocuments.vue?vue&type=script&lang=js&"
export * from "./PurchasingDocuments.vue?vue&type=script&lang=js&"
import style0 from "./PurchasingDocuments.vue?vue&type=style&index=0&id=64814f13&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64814f13",
  null
  
)

export default component.exports